// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dZGuLJnpYnLepP .SuSf2nkxLYexZQ {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.dZGuLJnpYnLepP .SuSf2nkxLYexZQ .M7ggTq9ic1xX3R .zqdsM_lyvwQQCk {
  display: flex;
  align-items: center;
}
.dZGuLJnpYnLepP .SuSf2nkxLYexZQ .M7ggTq9ic1xX3R .zqdsM_lyvwQQCk .ZsKJSwXHkF05Pg {
  margin: 4px 0;
}
.dZGuLJnpYnLepP .SuSf2nkxLYexZQ .M7ggTq9ic1xX3R .zqdsM_lyvwQQCk .wkAtRjvFC3hKzB {
  color: var(--ds-text-subtle, #44546f);
}
.dZGuLJnpYnLepP .SuSf2nkxLYexZQ .M7ggTq9ic1xX3R .zqdsM_lyvwQQCk .wkAtRjvFC3hKzB:hover {
  text-decoration: none;
}
.dZGuLJnpYnLepP .SuSf2nkxLYexZQ .jBzldBA1E7lcGN .n0Vvi4qXv312pQ {
  margin-right: 8px;
}
.dZGuLJnpYnLepP .SuSf2nkxLYexZQ .jBzldBA1E7lcGN .n0Vvi4qXv312pQ > span {
  display: inline-block;
  width: 18px;
  height: 18px;
  margin: 0 -2px 2px 6px;
}
@media only screen and (max-width: 700px) {
  .dZGuLJnpYnLepP .SuSf2nkxLYexZQ {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 20px;
  }
  .dZGuLJnpYnLepP .SuSf2nkxLYexZQ .NwQafTql5mbXY4 {
    margin: 12px;
  }
}
.dZGuLJnpYnLepP .fa2Ahpyu55A_42 {
  margin: 0;
}
.dZGuLJnpYnLepP .ooYneMBk4s4deY {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  background-color: var(--ds-background-warning, #fff7d6);
}
.dZGuLJnpYnLepP .ooYneMBk4s4deY .oKOJWa3Svfd4Fm {
  display: flex;
  align-items: center;
  height: inherit;
  margin-left: 10px;
}
.dZGuLJnpYnLepP .ooYneMBk4s4deY .oKOJWa3Svfd4Fm .c62nHnlieYPAW3 {
  margin-right: 10px;
}
.dZGuLJnpYnLepP .ooYneMBk4s4deY .oKOJWa3Svfd4Fm button {
  margin-bottom: 0;
}
.dZGuLJnpYnLepP .ooYneMBk4s4deY .NwQafTql5mbXY4 {
  display: flex;
  align-items: center;
  height: inherit;
}
.dZGuLJnpYnLepP .ooYneMBk4s4deY .NwQafTql5mbXY4 button {
  margin: 0 12px 0 0;
}
@media only screen and (max-width: 700px) {
  .dZGuLJnpYnLepP .ooYneMBk4s4deY {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 80px;
  }
  .dZGuLJnpYnLepP .ooYneMBk4s4deY .NwQafTql5mbXY4 {
    margin: 12px;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `dZGuLJnpYnLepP`,
	"multiSelectControls": `SuSf2nkxLYexZQ`,
	"leftControls": `M7ggTq9ic1xX3R`,
	"selectAllCheckboxContainer": `zqdsM_lyvwQQCk`,
	"checkbox": `ZsKJSwXHkF05Pg`,
	"selectAllLabel": `wkAtRjvFC3hKzB`,
	"rightControls": `jBzldBA1E7lcGN`,
	"addSelected": `n0Vvi4qXv312pQ`,
	"rightSide": `NwQafTql5mbXY4`,
	"multiSelectControlsDivider": `fa2Ahpyu55A_42`,
	"listControl": `ooYneMBk4s4deY`,
	"leftSide": `oKOJWa3Svfd4Fm`,
	"numOfSelected": `c62nHnlieYPAW3`
};
export default ___CSS_LOADER_EXPORT___;
